module.exports = __webpack_public_path__ + "static/media/ecommerce.6c73dd40.png";